import {
  Modal as MantineModal,
  ModalCloseButtonProps,
  ModalContentProps,
  ModalRootProps,
  rem,
  ModalBaseStylesNames,
  ScrollArea,
  ModalBaseProps
} from '@mantine/core';
import { CSSProperties, ReactNode } from 'react';

import classes from './Modal.module.scss';
import { HEADER_HEIGHT_PX } from '../../../client/consts/styleConsts';
import { MODAL_PORTAL_ID } from '../../../utils/consts';

type Modal = {
  opened: boolean;
  children: ReactNode;
  title?: string;
  dataTestPrefix?: string;
  modalContentProps?: ModalContentProps;
  closeButtonProps?: ModalCloseButtonProps;
  overridingClasses?: Partial<Record<ModalBaseStylesNames, string>>;
  styles?: Partial<Record<ModalBaseStylesNames, CSSProperties>>;
  size?: ModalBaseProps['size'];
} & ModalRootProps;

export function Modal(props: Modal) {
  const {
    title,
    children,
    dataTestPrefix = 'modal',
    modalContentProps,
    closeButtonProps,
    overridingClasses,
    styles,
    size = 'xl',
    ...modalRootProps
  } = props;

  return (
    <MantineModal.Root
      classNames={{
        header: classes.modalHeader,
        inner: classes.modalInner,
        content: classes.modalContent,
        close: classes.closeButton,
        title: classes.title,
        ...overridingClasses
      }}
      styles={styles}
      scrollAreaComponent={ScrollArea.Autosize}
      yOffset={rem(HEADER_HEIGHT_PX)}
      size={size}
      centered
      {...modalRootProps}
    >
      <MantineModal.Overlay />
      <MantineModal.Content id={MODAL_PORTAL_ID} {...modalContentProps}>
        <MantineModal.Header>
          <MantineModal.Title>{title}</MantineModal.Title>
          <MantineModal.CloseButton
            variant="transparent"
            color="accent"
            data-testid={`${dataTestPrefix}-close`}
            {...closeButtonProps}
          />
        </MantineModal.Header>
        <MantineModal.Body data-testid={`${dataTestPrefix}-content`}>{children}</MantineModal.Body>
      </MantineModal.Content>
    </MantineModal.Root>
  );
}
